"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAvatarContainer = exports.StyledBlockText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Tokens = __importStar(require("../../styles/tokens"));
const Text_1 = require("../Text/Text");
const AVATAR_COLOURS = {
    blue: {
        background: Tokens.COLOURS.primary.blue[25],
        border: Tokens.COLOURS.primary.blue[50],
    },
    green: {
        background: Tokens.COLOURS.primary.green[25],
        border: Tokens.COLOURS.primary.green[50],
    },
    grey: {
        background: Tokens.COLOURS.greyscale.dishwater,
        border: Tokens.COLOURS.greyscale.silver,
    },
    white: {
        background: Tokens.COLOURS.greyscale.white,
        border: Tokens.COLOURS.greyscale.silver,
    },
    pink: {
        background: Tokens.COLOURS.primary.pink[25],
        border: Tokens.COLOURS.primary.pink[50],
    },
};
const AVATAR_SIZES = {
    extraLarge: "3rem",
    large: "2.5rem",
    medium: "2rem",
    small: "1.5rem",
};
exports.StyledBlockText = (0, styled_components_1.default)(Text_1.Text) `
    display: block;
    text-decoration: none;
`;
exports.StyledAvatarContainer = styled_components_1.default.span `
    display: flex;
    justify-content: center;
    align-items: center;

    width: ${({ size }) => AVATAR_SIZES[size]};
    height: ${({ size }) => AVATAR_SIZES[size]};
    min-width: ${({ size }) => AVATAR_SIZES[size]};
    min-height: ${({ size }) => AVATAR_SIZES[size]};

    background-color: ${({ colour }) => AVATAR_COLOURS[colour].background};
    border-radius: ${Tokens.BORDERS.radius};
    border: 1px solid ${({ colour }) => AVATAR_COLOURS[colour].border};

    /*
    These styles are required while we use Bootstrap in consuming apps.
    Bootstrap applies these styles to abbr elements which we don't want.
     */
    abbr[title] {
        border-bottom: none;
        cursor: inherit;
        text-decoration: none;
    }
`;
//# sourceMappingURL=Avatar.styles.js.map